import React from 'react';
import { ClubR } from '@rakutenfrance/shared-svg';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { useStyles } from './ClubBalanceCard.style';
import { CurrencyFormatter } from '../CurrencyFormatter';
export const ClubBalanceCard = ({ balance, iconWidth = '50', iconHeight = '12', small = true, }) => {
    const classes = useStyles();
    return (React.createElement(Box, { sx: classes.balance },
        React.createElement(Box, { sx: classes.clubR },
            React.createElement(ClubR, { width: `${iconWidth}`, height: `${iconHeight}` })),
        React.createElement(Divider, { sx: classes.divider, orientation: "vertical", flexItem: true }),
        React.createElement(Typography, { sx: Object.assign(Object.assign({}, classes.amountBalance), (small && { fontSize: 'smaller' })), variant: "subtitle2" },
            React.createElement(CurrencyFormatter, { amount: balance }))));
};
